module.exports = __webpack_public_path__ + "static/media/pic11.0d39a0db.jpeg";